import { render, staticRenderFns } from "./wallet-login.vue?vue&type=template&id=51c45fdd&scoped=true&"
import script from "./wallet-login.vue?vue&type=script&lang=js&"
export * from "./wallet-login.vue?vue&type=script&lang=js&"
import style0 from "./wallet-login.vue?vue&type=style&index=0&id=51c45fdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c45fdd",
  null
  
)

export default component.exports